import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  input,
  model,
  output,
} from '@angular/core';
import {
  ParentTableColumns,
  TableCheckValue,
  TableColumns,
} from '../table/table.model';
import { NgTemplateOutlet } from '@angular/common';
import { LoaderComponent } from '../loader/loader.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-expandable-table',
  imports: [NgTemplateOutlet, LoaderComponent, ReactiveFormsModule],
  templateUrl: './expandable-table.component.html',
  styleUrl: './expandable-table.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExpandableTableComponent implements OnInit {
  id = input.required<string>();
  dataSource = input.required<any[]>();
  columns = input.required<TableColumns[]>();
  parentColumns = input<ParentTableColumns[]>([]);
  displayedColumns: TableColumns[] = [];
  bodyTemplateRef = model.required<TemplateRef<any>[]>();
  selectable = input<boolean>(false);
  handleMasterSelect = output<TableCheckValue>();
  handleSelectItem = output<TableCheckValue>();
  stickyHeader = input<boolean>(false);
  tableClass = input<string>('');
  cellStyle = input<string>('');
  rowStyle = input<string>('');
  isAllSelected = false;
  selectionItems: any[] = [];
  tableAction = input<boolean>(false);
  tableTitle = input<string>('');
  tableExport = input<boolean>(false);
  handleTableExport = output();
  tableFilter = input<boolean>(false);
  handleTableFilter = output();
  tableFilterSearch = input<boolean>(false);
  handleTableFilterSearch = output();
  noDataImg = input<string>('');
  noDataTitle = input<string>('');
  noDataDescription = input<string>('');
  loading = input<boolean>(false);

  ngOnInit() {
    this.displayedColumns = this.columns();
  }

  toggleAll(event: any) {
    const checked = event.target.checked;
    if (checked) {
      this.isAllSelected = true;
      this.dataSource().forEach(data => {
        if (this.selectionItems.indexOf(data) < 0) {
          this.selectionItems.push(data);
        }
      });
    } else {
      this.selectionItems = [];
      this.isAllSelected = false;
    }

    this.handleMasterSelect.emit({
      checked: checked,
      value: checked ? this.dataSource() : [],
    });
  }

  toggleElement(event: any, row: any) {
    const checked = event.target.checked;
    if (checked) {
      this.selectionItems.push(row);
      this.selectionItems.length == this.dataSource().length
        ? (this.isAllSelected = true)
        : (this.isAllSelected = false);
    } else {
      const index = this.selectionItems.indexOf(row);
      this.selectionItems.splice(index, 1);
      this.isAllSelected = false;
    }
    this.handleSelectItem.emit({
      checked: checked,
      value: this.selectionItems,
    });
  }

  isSelected(row: any): boolean {
    return this.selectionItems.indexOf(row) >= 0;
  }

  onTableExportClicked() {
    this.handleTableExport.emit();
  }

  onTableFilterClicked() {
    this.handleTableFilter.emit();
  }

  onTableFilterSearchClicked() {
    this.handleTableFilterSearch.emit();
  }

  toggleChildren(row: any) {
    row.expand = !row.expand;
  }
}
